import { cva } from 'class-variance-authority';

const vehicleCardStyles = cva(
	'bg-white border border-[#e9e9f5] rounded-2xl',
	{
		variants: {
			layout: {
				desktop: 'flex flex-row items-center gap-[var(--ds-spacing-size-16,16px)] pr-4',
				mobile: 'flex flex-col'
			}
		},
		defaultVariants: {
			layout: 'desktop'
		}
	}
);

const cardImageStyles = cva('relative overflow-hidden rounded-2xl shrink-0', {
	variants: {
		layout: {
			desktop: 'w-[156px] h-[156px]',
			mobile: 'w-full aspect-[3/2]'
		}
	},
	defaultVariants: {
		layout: 'desktop'
	}
});

const cardContentStyles = cva('', {
	variants: {
		layout: {
			desktop: 'flex flex-1 items-start gap-4 min-w-0',
			mobile: 'flex flex-col gap-3 p-4'
		}
	},
	defaultVariants: {
		layout: 'desktop'
	}
});

const cardInfoStyles = cva('flex flex-col gap-2 min-w-0', {
	variants: {
		layout: {
			desktop: 'flex-1',
			mobile: 'w-full'
		}
	},
	defaultVariants: {
		layout: 'desktop'
	}
});

const cardActionsContainerStyles = cva('flex flex-col shrink-0', {
	variants: {
		layout: {
			desktop: 'items-end justify-between self-stretch',
			mobile: 'items-stretch gap-2'
		}
	},
	defaultVariants: {
		layout: 'desktop'
	}
});

const statusTagStyles = cva(
	'inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-semibold leading-[1.3] uppercase tracking-wide whitespace-nowrap',
	{
		variants: {
			status: {
				active: 'bg-[#e1f1e7] text-[#2e2d37]',
				pending: 'bg-[#daf1f6] text-[#2e2d37]',
				inactive: 'bg-[#e9e9f5] text-[#2e2d37]',
				incomplete: 'bg-[#fef3c7] text-[#2e2d37]',
				payment_pending: 'bg-[#fef3c7] text-[#2e2d37]',
				payment_unauthorized: 'bg-[#fde8ec] text-[#2e2d37]'
			}
		},
		defaultVariants: {
			status: 'active'
		}
	}
);

const statusDotStyles = cva('w-1.5 h-1.5 rounded-full shrink-0', {
	variants: {
		status: {
			active: 'bg-[#22c55e]',
			pending: 'bg-[#06b6d4]',
			inactive: 'bg-[#6a6977]',
			incomplete: 'bg-[#f59e0b]',
			payment_pending: 'bg-[#f59e0b]',
			payment_unauthorized: 'bg-[#e22446]'
		}
	},
	defaultVariants: {
		status: 'active'
	}
});

const actionButtonStyles = cva(
	'inline-flex items-center justify-center gap-1.5 px-4 py-0 min-h-[32px] rounded-lg text-xs font-bold leading-[1.3] transition-colors cursor-pointer',
	{
		variants: {
			variant: {
				primary: 'bg-[#e22446] text-white hover:bg-[#c41f3d]',
				secondary: 'bg-transparent text-[#2e2d37] hover:bg-[#f5f5fa]',
				outline: 'border border-[#2e2d37] text-[#2e2d37] hover:bg-[#f5f5fa]'
			}
		},
		defaultVariants: {
			variant: 'primary'
		}
	}
);

const menuButtonStyles =
	'flex items-center justify-center w-6 h-6 rounded-full hover:bg-[#f5f5fa] transition-colors cursor-pointer';

const menuButtonOverlayStyles =
	'flex items-center justify-center w-6 h-6 rounded-full bg-white/80 shadow-md hover:bg-white transition-colors cursor-pointer';

const styles = {
	imageWrapper: 'absolute inset-0',
	imageGradient: 'absolute inset-0 bg-gradient-to-b from-transparent from-[81%] to-black rounded-2xl',
	image: 'w-full h-full object-cover rounded-2xl transition-opacity duration-300',
	imageHidden: 'opacity-0',
	imageVisible: 'opacity-100',
	imageSkeleton: 'absolute inset-0 rounded-2xl bg-[#ededf5] animate-pulse',
	imagePlaceholder: 'w-full h-full bg-[#f5f5fa] flex items-center justify-center rounded-2xl',
	imagePlaceholderNoPhoto: 'w-full h-full bg-[#ededf5] flex items-center justify-center rounded-2xl',

	title: 'text-[20px] font-bold text-black leading-[1.3] truncate font-[Figtree,sans-serif]',
	version: 'text-[14px] font-normal text-[#6a6977] leading-[1.4] truncate font-[Figtree,sans-serif]',
	yearKm: 'text-[14px] font-bold text-[#2e2e3a] leading-[1.4] font-[Figtree,sans-serif]',

	metricsContainer: 'flex items-start gap-2 flex-wrap',
	metricItem: 'flex items-center gap-0.5 text-[12px] text-[#2e2e3a] font-normal leading-[1.3] font-[Figtree,sans-serif]',
	metricIcon: 'w-4 h-4 text-[#2e2e3a] shrink-0',

	price: 'text-[20px] font-bold text-black leading-[1.3] font-[Figtree,sans-serif]',
	priceContainer: 'flex items-center gap-2',

	actionsRow: 'flex items-center gap-2',
	statusRow: 'flex items-center gap-2',

	menuButtonAbsolute: 'absolute top-2 right-2',
	mobileImageWrapper: 'relative',
	mobileContent: 'flex flex-col gap-3 p-4',
	photoPlaceholderIcon: 'w-12 h-12 text-[#c1c1d1]',
	infoStack: 'flex flex-col gap-0.5'
};

export {
	vehicleCardStyles,
	cardImageStyles,
	cardContentStyles,
	cardInfoStyles,
	cardActionsContainerStyles,
	statusTagStyles,
	statusDotStyles,
	actionButtonStyles,
	menuButtonStyles,
	menuButtonOverlayStyles,
	styles
};
